import React, { useContext } from 'react';
import { debounce } from 'lodash';
import FilterCtx from '../../../../context/filterContext/filterCtx';
import useTranslate from '../../../../common/hooks/useTranslate';

import '../filters.scss';
import './docNameFilter.scss';

interface DocName {
  table?: string;
  className?: string;
}

const DocNameFilter: React.FC<DocName> = ({ table, className }) => {
  const filterCtx: any = useContext(FilterCtx);

  const { t } = useTranslate();

  const handleInputChange = debounce((event: any) => {
    if (table === 'documents') {
      filterCtx.setDocName(event.target.value);
    } else {
      filterCtx.setDocNameActivity(event.target.value);
    }
  }, 500);

  return (
    <div className={`name-filter-wrapper ${className}`}>
      <input
        className="ci-input"
        type="search"
        placeholder={t('FILTERS.SEARCH')}
        onChange={handleInputChange}
        defaultValue={table === 'documents' ? filterCtx.docName : filterCtx.docNameActivity}
      />
    </div>
  );
};

export default DocNameFilter;
